import styled from "@emotion/styled";

const FooterContainer = styled.div`
  color: rgba(74, 84, 102, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  font-size: 12px;
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 390px;
`;

const TermsText = styled.div`
  line-height: 20px;
  text-align: center;

  & a {
    color: inherit;
  }
`;

const FooterLinkRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
  & a {
    color: inherit;
  }
`;

export const Footer = () => (
  <FooterContainer>
    <TermsText>
      By proceeding you acknowledge that you have read, understood and agree to
      our <a href="https://www.porchpass.com/terms">Terms and Conditions</a>.
    </TermsText>
    <FooterLinkRow>
      <a href="https://www.porchpass.com/privacy">Privacy</a>
      <a href="https://www.porchpass.com/contact">Support</a>
      <span>© 2025 PorchPass Inc.</span>
    </FooterLinkRow>
  </FooterContainer>
);
